import React from 'react';
import { FaWifi, FaExclamationTriangle, FaRedo } from 'react-icons/fa';

const NetworkError = ({ onRetry, message = "Network connection lost" }) => {
  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-6 md:p-8 mx-4 max-w-md w-full">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center">
            <FaWifi className="w-10 h-10 text-red-500" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 text-center mb-3 poppins">
          Network Error
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-6 text-sm md:text-base">
          {message}
        </p>

        {/* Warning */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-6">
          <div className="flex items-center">
            <FaExclamationTriangle className="w-5 h-5 text-yellow-600 mr-2" />
            <p className="text-yellow-800 text-sm">
              Please check your internet connection and try again.
            </p>
          </div>
        </div>

        {/* Retry Button */}
        <button
          onClick={onRetry}
          className="w-full bg-primary text-white py-3 px-6 rounded-xl font-semibold hover:bg-primary-dark transition-colors duration-300 flex items-center justify-center space-x-2"
        >
          <FaRedo className="w-4 h-4" />
          <span>Try Again</span>
        </button>
      </div>
    </div>
  );
};

export default NetworkError;
